export default "__VITE_ASSET__D77F1HDp__"